
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BorgCR10',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/BorgCR10.vue